export const agency = {
  activities: {
    activities: 'Aktiviteter',
    upcomingRenewals: 'Kommande Förnyelser',
    subscriptionActivities: 'Prenumerationsaktiviteter',
    upcomingDowngradeRequests: 'Kommande Nedgraderingsförfrågningar',
    serialNumber: 'Sr. No.',
    email: 'E-post',
    phoneNumber: 'Telefonnr',
    currentPlan: 'Nuvarande Plan',
    price: 'Pris',
    daysLeft: `Dagar Kvar`,
    noDataFound: {
      upcomingDowngrades: 'Kommande Nedgraderingar',
      noUpcomingDowngradesFoundYet:
        'Inga kommande nedgraderingar hittade ännu!',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Kommande förnyelser av kunder',
      subscriptionActivities: 'Prenumerationsaktiviteter',
      upcomingDowngradeRequestsOfCustomers:
        'Kommande nedgraderingsförfrågningar av kunder',
      serialNumber: 'Serienummer',
      customerEmail: 'Kundens e-post',
      customerPhoneNumber: 'Kundens telefonnummer',
      currentPlanOfCustomer: 'Nuvarande plan för kunden',
      currentPlanPrice: 'Nuvarande plan pris',
      daysLeft: `Dagar kvar av kundens nuvarande plan`,
    },
  },
  configuration: {
    configurationsHeader: 'Konfigurationer',
    emailHeader: 'E-post',
    razorPayHeader: 'RazorPay',
    invoiceDetailsHeader: 'Fakturadetaljer',
    stripeHeader: 'Stripe',
    retentionPolicyHeader: 'Bevaringspolicy',
    zohoHeader: 'Zoho',
    appTooltip: {
      integrateYourEmailProviderDetails:
        'Integrera detaljer från din e-postleverantör för att skicka kundmeddelanden sömlöst.',
      enterYourRazorPayAccountDetails:
        'Ange detaljer för ditt RazorPay-konto för sömlös hantering av kundbetalningar.',
      enterYourStripeAccountDetails:
        'Ange detaljer för ditt Stripe-konto för sömlös hantering av kundbetalningar.',
      enterYourCompanyDetails:
        'Ange dina företagsdetaljer för exakt fakturering och professionell fakturagenerering.',
      enterYourZohoKeys:
        'Ange din Zoho-klient-ID och Zoho-klienthemliga nyckel för en lyckad integration.',
      retentionPolicyDescription: 'Bevaringspolitikken er designet til at administrere dataens livscyklus inden for systemet.',
      enterYourGoogleKeys: 'Ange din Google Client ID och Google Client Secret Key för en lyckad integration.',
    },
    email: {
      testEmail: 'Testa e-post',
      addEmailIntegrationsDetails: 'Lägg till detaljer för e-postintegration',
      integrationDescription:
        'För att integrera detaljer från din e-postleverantör, vänligen ange informationen för din e-postleverantör. All kommunikation via e-post kommer att skickas till dina kunder med den här e-postadressen för konsekvent och pålitlig leverans av viktiga meddelanden och uppdateringar.',
      awsRegion: 'AWS-region',
      awsAccessKeyId: 'AWS Access Key ID',
      awsSecretAccessKey: 'AWS Secret Access Key',
      reset: 'Återställ',
      addDetails: 'Lägg till detaljer',
      updateDetails: 'Uppdatera detaljer',
      fromEmail: 'Från e-post',
      appTooltip: {
        TOOLTIP_AWS_REGION:
          'Ange din AWS-region. Regionen avgör den fysiska platsen för dina resurser och påverkar faktorer som datalatens och regelverksmässig överensstämmelse.',
        TOOLTIP_AWS_ACCESS_KEY_ID:
          'Ange din AWS Access Key ID. Den här nyckeln identifierar unikt ditt AWS-konto och krävs för säker autentisering och åtkomst till AWS-tjänster.',
        TOOLTIP_AWS_SECRET_ACCESS_KEY_ID:
          'Ange din AWS Secret Access Key. Den här nyckeln används för säker autentisering och åtkomst till AWS-tjänster.',
          fromEmail: 'E-postadress som används för att skicka e-post från alla plattformmeddelanden (till exempel ledmeddelanden, kontosignaler osv.)',
      },
      placeholders: {
        enterAwsRegion: 'Ange AWS-region',
        enterAwsAccessKeyId: 'Ange AWS Access Key ID',
        enterAwsSecretAccessKey: 'Ange AWS Secret Access Key',
        enterFromEmail: 'Ange från e-post',
      },
      modal: {
        deleteEmailIntegration: 'Ta bort e-postintegration',
        wantToDeleteEmailIntegration:
          'Är du säker på att du vill ta bort denna e-postintegration?',
      },
    },
    facebook: {
      addFacebookIntegrationsDetails:
        'Lägg till detaljer för Facebook-integration',
      integrateYourEmailProviderDetails:
        'Integrera detaljer från din e-postleverantör. Alla e-postmeddelanden skickas till dina kunder med denna e-postadress',
      facebookAppId: 'Facebook App ID',
      facebookSecretAccessKey: 'Facebook Secret Access Key',
      reset: 'Återställ',
      cancel: 'Avbryt',
      addDetails: 'Lägg till detaljer',
      updateDetails: 'Uppdatera detaljer',
      delete: 'Ta bort',
      testEmail: 'Testa e-post',
      modal: {
        deleteFacebookIntegration: 'Ta bort Facebook-integration',
        wantToDeleteFacebookIntegration:
          'Är du säker på att du vill ta bort denna Facebook-integration?',
      },
      placeholders: {
        enterFacebookAccessKeyId: 'Ange Facebook Secret Access Key',
        enterFacebookAppId: 'Ange Facebook App ID',
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES:
          'Anpassa meddelandet som du vill att det ska visas på chattfönstret omedelbart efter att en botanvändare har begärt Live Chat',
      },
    },
    invoiceDetails: {
      addInvoiceDetails: 'Lägg till fakturadetaljer',
      invoicesDescription:
        'För att generera fakturor för dina kunder, ange dina företagsdetaljer, inklusive företagsnamn, adress, kontaktinformation och annan relevant information som krävs för exakt fakturering. Denna information kommer att användas för att skapa professionella fakturor på uppdrag av ditt företag för varje transaktion.',
      companyName: 'Företagsnamn',
      country: 'Land',
      selectCountry: 'Välj land',
      stateOrRegion: 'Stat/Region',
      streetAddress: 'Gatuadress',
      gstin: 'GSTIN',
      postalCode: 'Postnummer',
      addDetails: 'Lägg till detaljer',
      updateDetails: 'Uppdatera detaljer',
      reset: 'Återställ',
      delete: 'Ta bort',
      loadMore: 'Läs in mer',
      time: 'Tid',
      phoneNumber: 'Telefonnummer',
      email: 'E-post',
      status: 'Status',
      message: 'Meddelande',
      response: 'Svar',
      placeOfSupply: 'Leveransplats',
      placeholders: {
        enterYourCompanyName: 'Ange ditt företagsnamn',
        enterYourStateOrRegion: 'Ange din stat/region',
        enterYourStreetAddress: 'Ange din gatuadress',
        enterYourGstin: 'Ange ditt GSTIN',
        enterPostalCode: 'Ange postnummer',
        enterPlaceOfSupply: 'Ange leveransplats',
      },
      modal: {
        deleteEmailIntegration: 'Ta bort e-postintegration',
        wantToDeleteEmailIntegration:
          'Är du säker på att du vill ta bort denna e-postintegration?',
      },
      appTooltip: {
        TOOLTIP_COMPANY_NAME:
          'Ange ditt företagsnamn. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_COUNTRY:
          'Välj ditt land. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_STATE:
          'Ange din stat. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_STREET_ADDRESS:
          'Ange din gatuadress. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_GSTIN:
          'Ange din GSTIN. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_POSTAL_CODE:
          'Ange ditt postnummer. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
        TOOLTIP_PLACE_OF_SUPPLY:
          'Ange din leveransplats. Denna information kommer att användas för identifiering och varumärkesändamål i fakturor.',
      },
    },
    razorPay: {
      addRazorPayIntegrationsDetails:
        'Lägg till detaljer för RAZORPAY-integration',
      integrationDescription:
        'För att integrera detaljer från ditt RazorPay-konto, ange ditt RazorPay-kontoinformation. Alla kundbetalningar kommer att behandlas genom ditt RazorPay-konto för sömlösa transaktioner',
      razorPayAccessKeyId: 'RAZORPAY Access Key Id',
      razorPaySecretAccessKey: 'RAZORPAY Secret Access Key',
      reset: 'Återställ',
      addDetails: 'Lägg till detaljer',
      updateDetails: 'Uppdatera detaljer',
      loadMore: 'Läs in mer',
      time: 'Tid',
      phoneNumber: 'Telefonnummer',
      email: 'E-post',
      status: 'Status',
      message: 'Meddelande',
      response: 'Svar',
      placeholders: {
        enterRazorPayAccessKeyId: 'Ange Razorpay Access Key Id',
        enterRazorPaySecretAccessKey: 'Ange Razorpay Secret Access Key',
        enterRazorPayAccessId: 'Ange RazorPay Access Id',
      },
      appTooltip: {
        TOOLTIP_RAZORPAY_ID:
          'Ange ditt Razorpay Access Key ID. Denna nyckel identifierar unikt din integration med Razorpay och krävs för säkra betalningstransaktioner.',
        TOOLTIP_RAZORPAY_SECRET_KEY:
          'Ange din Razorpay Secret Access Key. Denna nyckel är nödvändig för säker kommunikation mellan applikationen och Razorpay, vilket möjliggör sömlös transaktionshantering och betalningshantering.',
      },
      modal: {
        deleteRazorPayIntegration: 'Ta bort e-postintegration',
        wantToDeleteThisIntegrtion:
          'Är du säker på att du vill ta bort denna e-postintegration?',
      },
    },
    stripe: {
      addStripeIntegrationDetails: 'Lägg till detaljer för Stripe-integration',
      integrationDescription:
        'För att integrera detaljer från ditt Stripe-konto, ange din Stripe-kontoinformation. Alla kundbetalningar kommer att behandlas genom ditt Stripe-konto för sömlösa transaktioner',
      stripeSecretAccessKey: 'Stripe Secret Access Key',
      stripePublicKey: 'Stripe Public Key',
      reset: 'Återställ',
      addDetails: 'Lägg till detaljer',
      updateDetails: 'Uppdatera detaljer',
      cancel: 'Avbryt',
      loadMore: 'Läs in mer',
      time: 'Tid',
      phoneNumber: 'Telefonnummer',
      email: 'E-post',
      status: 'Status',
      message: 'Meddelande',
      response: 'Svar',
      placeholders: {
        enterStripeSecretAccessKey: 'Ange Stripe Secret Access Key',
        enterStripePublicKey: 'Ange Stripe Public Key',
      },
      appTooltip: {
        TOOLTIP_STRIPE_SECRET_KEY:
          'Ange din Stripe Secret Access Key. Denna nyckel används för att säkert autentisera din integration med Stripe och är nödvändig för att behandla kundbetalningar.',
        TOOLTIP_PUBLIC_KEY:
          'Ange din Stripe Public Key. Denna nyckel används för att säkert autentisera din integration med Stripe på klientens sida och är nödvändig för att behandla kundbetalningar.',
      },
      modal: {
        deleteStripeIntegration: 'Ta bort Stripe-integration',
        wantToDeleteStripeIntegration:
          'Är du säker på att du vill ta bort denna Stripe-integration?',
      },
    },
    retentionPolicy: {
      retentionPolicy: 'Bevaringspolitik',
      retentionPolicyDescription: 'Bevaringspolitikken er designet til at administrere dataens livscyklus inden for systemet og angiver, hvor længe data skal bevares, før det fjernes systematisk og sikkert. Denne politik sigter mod at sikre overholdelse af databeskyttelsesregler, optimere lagerressourcer og administrere data på en effektiv og organiseret måde.',
      apiLogs: 'API-log Bevaringsdage',
      selectApiLogs: 'Vælg API-log Bevaringsdage',
      update: 'Opdater',
      save: 'Gem',
      day: 'dag',
      days: 'dage',
      placeholders: {
        enterNumberOfDays: 'Indtast antal dage'
      },
    },
    zoho: {
      addZohoIntegrationDetails: 'Lägg till detaljer för Zoho-integration',
      zohoDescription: `Anslut din chatbot-plattform med Zoho CRM, Zoho Projects och Zoho Desk utan ansträngning. Det kommer att möjliggöra för dina användare att automatiskt överföra sina chatbots fångade ledningsdata och skapa uppgifter i respektive Zoho-moduler. För att initiera en framgångsrik integration, ange ditt Zoho-klient-ID och Zoho-klienthemliga nyckel.`,
      zohoClientId: 'Zoho Client Id',
      zohoClientSecret: 'Zoho Client Secret',
      zohoCrmExtensionUrl: 'Zoho CRM Extension URL',
      add: 'Lägg till',
      update: 'Uppdatera',
      placeholders: {
        enterZohoClientId: 'Ange ditt Zoho-klient-ID',
        enterZohoClientSecret: 'Ange ditt Zoho-klienthemliga nyckel',
        enterZohoCrmExtensionUrl: 'Ange din Zoho CRM Extension URL',
      },
    },
    google: {
      addGoogleIntegrationDetails: 'Lägg till detaljer för Google-integration',
      googleBeskrivning: `Anslut din Final_Brand med Google Tasks, Google Contacts, Google Calendar, Google Sheets och Google Analytics utan problem. Detta gör det möjligt för användare att ställa in arbetsflödesautomation genom att överföra chatbot-fångad data till föredragna Google-appar. För att starta en framgångsrik integration, ange din Google-klient-ID och Google-klienthemlighetsnyckel.`,
      googleClientId: 'Google klient-ID',
      googleClientSecret: 'Google klienthemlighetsnyckel',
      add: 'Lägg till',
      update: 'Uppdatera',
      placeholders: {
          enterGoogleClientId: 'Ange din Google klient-ID',
          enterGoogleClientSecret: 'Ange din Google klienthemlighetsnyckel',
      }
  }
  },
  customer: {
    manageCustomers: 'Hantera kunder',
    addNewCustomers: 'Lägg till nya kunder',
    ensureYouHaveAddedAllYourCustomersHere:
      'Se till att du har lagt till alla dina kunder här',
    customerName: 'Kundnamn',
    nameIsRequired: 'Namn krävs',
    emailId: 'E-post ID',
    enterAValidEmail: 'Ange en giltig e-postadress',
    createPassword: 'Skapa lösenord',
    enterAStrongPassword: 'Ange ett starkt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    cancel: 'Avbryt',
    customer: 'Kund',
    searchByNameOrEmail: 'Sök efter namn eller e-post',
    filters: 'Filter',
    allCustomers: 'Alla kunder',
    paidCustomers: 'Betalda kunder',
    freeCustomers: 'Gratis kunder',
    messageAddOnCustomers: 'Meddelandetilläggskunder',
    botWhiteLabelCustomers: 'Bot White Label-kunder',
    sortBy: 'Sortera efter',
    sortByFrequency: 'Sortera efter frekvens',
    all: 'Alla',
    joinedDate: 'Anslutningsdatum',
    plan: 'Plan',
    lastLogin: 'Senaste inloggningen',
    email: 'E-post',
    nextDue: 'Nästa förfallodatum',
    frequency: 'Frekvens',
    clearAll: 'Rensa alla',
    apply: 'Tillämpa',
    messageConsumed: 'Meddelanden konsumerade',
    addCustomer: 'Lägg till kund',
    serialNumber: 'Snr',
    name: 'Namn',
    contact: 'Kontakt',
    limit: 'Gräns',
    location: 'Plats',
    actions: 'Åtgärder',
    joinedOn: 'Ansluten den',
    typeOfCustomer: 'Typ av kund',
    exceptWhatsapp: ' (Förutom Whatsapp)',
    exceptWA: '(Förutom WA)',
    wa: '(WA)',
    loadMore: 'Läs in mer',
    conversationsWhatsapp: 'Samtal (Whatsapp)',
    appTooltip: {
      enterCustomerEmail: 'Ange kundens e-post',
      enterCustomerPassword: 'Ange kundens lösenord',
      enterCustomerConfirmPassword: 'Ange bekräfta lösenord för kunden',
      enterCustomerName: 'Ange kundens namn',
    },
    placeholders: {
      enterCustomerEmail: 'Ange kundens e-post',
      searchByNameOrEmail: 'Sök efter namn eller e-post',
      enterPassword: 'Ange lösenord',
      enterCustomerName: 'Ange kundens namn',
    },
  },
  dashboard: {
    dashboard: 'Instrumentpanel',
    overview: 'Översikt',
    totalCustomers: 'Totalt antal kunder',
    paidCustomers: 'Betalda kunder',
    freeCustomers: 'Gratis kunder',
    thisWeeksSignUp: 'Registreringar denna vecka',
    todaysSignUp: 'Dagens registreringar',
    totalEarnings: 'Totala intäkter',
    nA: 'Ej tillämpligt',
    customerName: 'Kundnamn',
    nameIsRequired: 'Namn krävs',
    emailId: 'E-post ID',
    enterAValidEmail: 'Ange en giltig e-postadress',
    editCustomer: 'Redigera kund',
    recentSignUps: 'Senaste registreringar',
    serialNumber: 'Snr',
    name: 'Namn',
    email: 'E-post',
    contact: 'Kontakt',
    plan: 'Plan',
    limit: 'Gräns',
    location: 'Plats',
    lastLogin: 'Senaste inloggningen',
    joinedOn: 'Ansluten den',
    actions: 'Åtgärder',
    exceptWhatsapp: ' (Förutom Whatsapp)',
    messageConsumed: 'Meddelanden konsumerade',
    conversationsWhatsapp: 'Samtal (Whatsapp)',
    placeholders: {
      enterCustomerName: 'Ange kundens namn',
      enterCustomerEmail: 'Ange kundens e-post',
    },
    modal: {
      deleteCustomer: 'Ta bort kund',
      areYouSure: 'Är du säker på att du vill ta bort denna kund?',
    },
  },
  downgradeRequests: {
    activites: 'Aktiviteter',
    upcomingRenewals: 'Kommande förnyelser',
    subscriptionActivities: 'Prenumerationsaktiviteter',
    upcomingDonwgradeRequests: 'Kommande nedgraderingsförfrågningar',
    serialNumber: 'Snr',
    email: 'E-post',
    phoneNumber: 'Telefonnummer',
    currentPlan: 'Nuvarande plan',
    requestedOn: 'Förfrågad den',
    downgradeOn: 'Nedgradera den',
    nA: 'Ej tillämpligt',
    commaMonthly: ', Månadsvis',
    commaYearly: ', Årlig',
    noDataFound: {
      downgradeRequests: 'Nedgraderingsförfrågningar',
      noDowngradeRequestFound: 'Inga nedgraderingsförfrågningar hittades ännu!',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Kommande förnyelser av kunder',
      subscriptionActivities: 'Prenumerationsaktiviteter',
      upcomingDowngradeOfCustomers:
        'Kommande nedgraderingsförfrågningar av kunder',
      serialNumber: 'Serienummer',
      customerEmail: 'Kundens e-post',
      customerPhoneNumber: 'Kundens telefonnummer',
      currentPlanOfCustomer: 'Kundens nuvarande plan',
      currentPlanPrice: 'Nuvarande planpris',
    },
  },
  emailIntegration: {
    emailIntegration: 'E-postintegration',
    addEmailIntegrationDetails: 'Lägg till detaljer för e-postintegration',
    integrateYourEmailProviderDetails:
      'Integrera detaljer från din e-postleverantör. Alla e-postmeddelanden skickas med denna e-post till dina kunder',
    awsRegion: 'AWS-region',
    awsRegionIsRequired: 'AWS-region krävs',
    awsAccessKeyId: 'AWS Access Key Id',
    awsAccessKeyIdIsRequired: 'AWS Access Key Id krävs',
    awsSecretAccessKey: 'AWS Secret Access Key',
    awsSecretAccessKeyIsRequired: 'AWS Secret Access Key krävs',
    cancel: 'Avbryt',
    test: 'Testa',
    action: 'Åtgärd',
    testEmail: 'Testa e-post',
    addDetails: 'Lägg till detaljer',
    updateDetails: 'Uppdatera detaljer',
    saveDetails: 'Spara detaljer',
    placeholders: {
      enterAwsRegion: 'Ange AWS-region',
      enterAwsAccessKeyId: 'Ange AWS Access Key Id',
      enterAwsSecretAccessKey: 'Ange AWS Secret Access Key',
    },
    modal: {
      deleteEmailIntegration: 'Ta bort e-postintegration',
      areYouSure: 'Är du säker på att du vill ta bort denna e-postintegration?',
    },
    noDataFound: {
      emailIntegration: 'E-postintegration',
      noEmailIntegrationFoundYet: 'Ingen e-postintegration hittades ännu!',
    },
  },
  subscription: {
    activities: 'Aktiviteter',
    upcomingRenewals: 'Kommande förnyelser',
    subscriptionActivities: 'Prenumerationsaktiviteter',
    upcomingDonwgradeRequests: 'Kommande nedgraderingsförfrågningar',
    filters: 'Filter',
    manageActivities: 'Hantera aktiviteter',
    sortBy: 'Sortera efter',
    all: 'Alla',
    upgrades: 'Uppgraderingar',
    donwgrades: 'Nedgraderingar',
    renewals: 'Förnyelser',
    serialNumber: 'Snr',
    email: 'E-post',
    phoneNumber: 'Telefonnummer',
    previousPlan: 'Föregående plan',
    newPlan: 'Ny plan',
    description: 'Beskrivning',
    date: 'Datum',
    nA: 'Ej tillämpligt',
    upgraded: 'uppgraderad',
    commaYearly: ', Årlig',
    commaMonthly: ', Månadsvis',
    noDataFound: {
      noSubscriptionActivitiesFoundYet:
        'Inga prenumerationsaktiviteter hittades ännu!',
      subscriptionsActivities: 'Prenumerationsaktiviteter',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Kommande förnyelser av kunder',
      subscriptionActivities: 'Prenumerationsaktiviteter',
      upcomingDowngradeRequests:
        'Kommande nedgraderingsförfrågningar av kunder',
      serialNumber: 'Serienummer',
      customerEmail: 'Kundens e-post',
      customerPhoneNumber: 'Kundens telefonnummer',
      previousPlan: 'Föregående plan för kunden',
      newPlan: 'Ny plan för kunden',
      description: 'Beskrivning av planen',
      typeOfPayment: 'Betaltyp',
    },
  },
  feedbacks: {
    feedbacks: 'Återkopplingar',
    serialNumber: 'Snr',
    customer: 'Kund',
    type: 'Typ',
    rating: 'Betyg',
    reason: 'Anledning',
    description: 'Beskrivning',
    createdAt: 'Skapad den',
    nA: 'Ej tillämpligt',
    loadMore: 'Läs in mer',
    dataNotFound: {
      accountAndBotDeletionFeedbacks:
        'Återkopplingar för konto och bot-borttagning',
      noFeedbacksFoundYet: 'Inga återkopplingar hittades ännu!',
    },
    appTooltip: {
      serialNumber: 'Serienummer',
      customerEmail: 'Kundens e-post',
      feedbackForBotOrAccountDeletion:
        'Återkoppling för (Bot/Kontoborttagning)',
      customerRating: 'Kundbetyg',
      customerReason: 'Kundens anledning',
      feedbackCreatedAt: 'Återkoppling skapad den',
      customerFeedback: 'Kundåterkoppling',
    },
  },
  emailActivity: {
    emailActivityHeading: 'E-postaktivitet',
    heading: 'Din e-postaktivitet',
    subHeading: 'E-postloggar för rotbyrå',
    searchLabel: 'Filtrera efter kundnamn',
    customerName: 'Kundens namn',
    emailType: 'E-posttyp',
    fromEmail: 'Från e-post',
    toEmail: 'Till e-post',
    createdAt: 'Skapad den',
    action: 'Åtgärd',
    loadMore: 'Läs in mer',
    noEmailActivityYet: 'Ingen e-postaktivitet hittades ännu!',
  },
};
